export const DIRECTIVE_NAME = FormControlsEnabled.DIRECTIVE_NAME = 'ktFormControlsEnabled';
export default function FormControlsEnabled() {
    return {
        restrict: 'A',
        controller: FormControlsEnabledController,
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.attributes = $attrs;
            $ctrl.$onInit();
        },
    };
}

export const CSS_CLASS_DISABLED = 'form-disable';

export function FormControlsEnabledController(
    $scope
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        initializeWatcher();
    }

    function initializeWatcher() {
        $scope.$watch(getValue, (value) => {
            const isEnabled = !!value;
            if (isEnabled) {
                vm.attributes.$removeClass(CSS_CLASS_DISABLED);
            } else {
                vm.attributes.$addClass(CSS_CLASS_DISABLED);
            }
        });
    }

    function getValue() {
        return $scope.$eval(vm.attributes[DIRECTIVE_NAME]);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/form-controls-enabled/form-controls-enabled-component.js